module.exports = __webpack_public_path__ + "img/material-kid-md.74f8a133.png";